import React from 'react';

export default function Home() {
    return (
        <video src="/video/start.mp4" width={1100} autoPlay={true} loop={true}>
            Your browser does not support the video tag.
        </video>
    )
}